import { Directive, ElementRef, HostBinding, HostListener, Input, Renderer2 } from '@angular/core';

@Directive({
	selector: '[appShare]',
	standalone: true
})
export class ShareDirective {
	@Input() shareTitle: string | undefined = 'Check this out!';
	@Input() shareText: string | undefined = 'Check out this amazing content!';
	@Input() shareUrl: string = window.location.href;

	@HostBinding('class.copied') isCopied: boolean = false;

	private isWebShareSupported = !!navigator.share;
	private originalIcon: string = 'icon-share-alt';

	constructor(
		private _renderer: Renderer2,
		private el: ElementRef
	) { }

	@HostListener('click')
	async onShare() {
		const shareData = {
			title: this.shareTitle,
			text: this.shareText,
			url: this.shareUrl
		};

		if (this.isWebShareSupported) {
			try {
				await navigator.share(shareData);
			} catch (err) {
				console.log(err)
			}
		} else {
			this.copyToClipboard(shareData.url);
		}
		this.toggleShareIcon();
	}

	private toggleShareIcon() {
		const buttonElement = this.el.nativeElement;
		const iconElement = buttonElement.querySelector('i');

		if (iconElement) {
			// Capture original icon class if not already stored
			if (!this.originalIcon) {
				this.originalIcon = iconElement.className;
			}

			// Add 'copied' class to the button for animation
			this._renderer.addClass(buttonElement, 'copied');

			// Prepare to swap icons with full class
			this._renderer.removeClass(iconElement, this.originalIcon);
			this._renderer.addClass(iconElement, 'icon-check');

			// Reset after animation completes
			setTimeout(() => {
				// Remove 'copied' class
				this._renderer.removeClass(buttonElement, 'copied');

				// Swap back to original icon
				this._renderer.removeClass(iconElement, 'icon-check');
				this._renderer.addClass(iconElement, this.originalIcon);
			}, 2000); // Slightly longer than the CSS animation duration
		}
	}

	private copyToClipboard(text: string) {
		const textarea = document.createElement('textarea');
		textarea.value = text;
		document.body.appendChild(textarea);
		textarea.select();
		document.execCommand('copy');
		document.body.removeChild(textarea);
	}
}